import axios from 'axios';
import config from '../../../config';
import Cookies from 'js-cookie';

const baseUrl = config.baseUrl; // URL base de tu API
const unidadesDeMedidaEndpoint = '/api/financiero/unidadesdemedida'; // Endpoint para consultar unidades de medida

// Crear una instancia de Axios con la configuración base
const api = axios.create({
    baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Función para listar todas las unidades de medida (oid, Unidad_medida)
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const getUnidadesDeMedida = async () => {
    try {
        const response = await api.get(unidadesDeMedidaEndpoint);
        return response.data;
    } catch (error) {
        console.error('Error al obtener las unidades de medida:', error.message || error);
        return {
            status: error.response ? error.response.status : 500,
            message: error.message || 'Error al obtener las unidades de medida',
        };
    }
};
